/* Product card image slider: one Swiper per card, infinite loop. Desktop fades a
   static featured image to reveal the slider on hover; mobile is touch slide.
   First slider image loads on page load, the rest on hover (desktop) / scroll-in (mobile). */
(function () {
  'use strict';

  if (typeof window.Swiper === 'undefined') return;

  var DESKTOP = window.matchMedia('(min-width: 750px)');
  var instances = new WeakMap();
  var SPEED = 300; // keep in sync with Swiper `speed`

  function initProgress(root, swiper) {
    var track = root.querySelector('.card-media-slider__progress');
    var bar = root.querySelector('.card-media-slider__progress-bar');
    var n = parseInt(root.getAttribute('data-slide-count'), 10) || swiper.slides.length;

    if (!track || !bar || n < 2) {
      if (track) track.style.display = 'none';
      return;
    }

    var widthPct = 100 / n;
    bar.style.width = widthPct + '%';
    root.classList.add('card-media-slider--has-progress');

    var prev = swiper.realIndex;
    var token = 0;

    function leftFor(i) {
      return (i * (100 - widthPct)) / (n - 1);
    }

    function setLeft(pct, animate) {
      bar.style.transition = animate ? 'left ' + SPEED + 'ms ease' : 'none';
      bar.style.left = pct + '%';
    }

    setLeft(leftFor(prev), false);

    function direction(p, c) {
      if (swiper.swipeDirection === 'next') return 1;
      if (swiper.swipeDirection === 'prev') return -1;
      if (c === (p + 1) % n) return 1;
      if (c === (p - 1 + n) % n) return -1;
      return 1;
    }

    swiper.on('slideChange', function () {
      var cur = swiper.realIndex;
      if (cur === prev) return;

      var dir = direction(prev, cur);
      var wrapFwd = dir === 1 && prev === n - 1 && cur === 0;
      var wrapBwd = dir === -1 && prev === 0 && cur === n - 1;
      var mine = ++token;

      if (!wrapFwd && !wrapBwd) {
        setLeft(leftFor(cur), true);
      } else {
        var exitTo = wrapFwd ? 100 : -widthPct;
        var enterFrom = wrapFwd ? -widthPct : 100;
        var done = false;

        setLeft(exitTo, true);

        var finish = function () {
          if (done || mine !== token) return;
          done = true;
          bar.removeEventListener('transitionend', finish);
          setLeft(enterFrom, false);
          void bar.offsetWidth; // commit the jump before animating in
          setLeft(leftFor(cur), true);
        };

        bar.addEventListener('transitionend', finish);
        setTimeout(finish, SPEED + 60); // fallback if transitionend never fires
      }

      prev = cur;
    });
  }

  function loadImg(img) {
    if (!img || !img.dataset.src) return;
    if (img.dataset.srcset) img.srcset = img.dataset.srcset;
    img.src = img.dataset.src;
    img.removeAttribute('data-src');
    img.removeAttribute('data-srcset');
  }

  function loadAllImages(root) {
    root.querySelectorAll('img[data-src]').forEach(loadImg);
  }

  function markReady(root) {
    var media = root.closest('.card__media');
    if (media) media.classList.add('card-media--ready');
  }

  // Desktop: fetch the rest of the images on hover (the first is already loaded,
  // so navigation is instant). Reset to the first slide on leave.
  function initDesktopHover(root, swiper) {
    var media = root.closest('.card__media') || root;
    media.addEventListener('mouseenter', function () {
      loadAllImages(root);
    });
    media.addEventListener('mouseleave', function () {
      swiper.slideToLoop(0, 0);
    });
  }

  function initSlider(el) {
    if (instances.get(el)) return;
    var swiperEl = el.querySelector('.swiper');
    if (!swiperEl) return;

    var desktop = DESKTOP.matches;

    // Desktop: move the featured slide to the end so the slider opens on the
    // first non-featured image.
    if (desktop) {
      var wrapper = swiperEl.querySelector('.swiper-wrapper');
      var featured = swiperEl.querySelector('[data-featured-slide]');
      if (wrapper && featured) wrapper.appendChild(featured);
    }

    var swiper = new window.Swiper(swiperEl, {
      loop: true,
      slidesPerView: 1,
      speed: SPEED,
      grabCursor: false, // card image is a link, not a drag handle
      threshold: 5,
      resistanceRatio: 0.6,
      navigation: {
        prevEl: el.querySelector('.card-media-slider__arrow--prev'),
        nextEl: el.querySelector('.card-media-slider__arrow--next'),
      },
    });

    instances.set(el, swiper);
    initProgress(el, swiper);

    if (desktop) {
      // Preload only the first non-featured image so the hover reveal is instant
      // and never blank; the rest load on hover. Reveal (fade featured) once it's in.
      var first = swiperEl.querySelector('.swiper-slide:first-child img[data-src]');
      if (first) {
        loadImg(first);
        if (first.complete && first.naturalWidth > 0) markReady(el);
        else first.addEventListener('load', function () { markReady(el); }, { once: true });
      } else {
        markReady(el);
      }
      initDesktopHover(el, swiper);
    } else {
      loadAllImages(el); // mobile: load the card's images as it scrolls into view
    }
  }

  var observer = 'IntersectionObserver' in window
    ? new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            initSlider(entry.target);
            observer.unobserve(entry.target);
          }
        });
      }, { rootMargin: '200px 0px' })
    : null;

  function enable() {
    document.querySelectorAll('[data-card-slider]').forEach(function (el) {
      if (instances.get(el)) return;
      if (observer) observer.observe(el);
      else initSlider(el);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', enable);
  } else {
    enable();
  }

  // Re-init cards added by facet AJAX / infinite scroll.
  var container = document.getElementById('ProductGridContainer');
  if (container && 'MutationObserver' in window) {
    var mo = new MutationObserver(function () { enable(); });
    mo.observe(container, { childList: true, subtree: true });
  }
})();
